module.exports = __webpack_public_path__ + "img/66TOP-FIANO-U-COLORI-LINO-STAMPE-LINOGONNA-GIN-U-RIC.GRECIA-RIC.LIMONE5.3c6c28ff.jpg";